import { CapoPlugin } from "/home/runner/_work/jbg-web/jbg-web/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];